import React from "react";
import "./LBTheme.scss";

const LBTheme = () => (
  <div className="product-hero-decoration" aria-hidden="true">
    <div className="product-hero-decoration-left" />
    <div className="product-hero-decoration-right" />
  </div>
);

export default LBTheme;
